import { createI18n } from 'vue-i18n'
import { nextTick } from 'vue'
import apiClient from '@u/apiClient'
import apiClientDocument from '@u/apiClientDocument'
import apiClientScreen from '@u/apiClientScreen.js'
import store from '@/store'
import LanguageController from '@/wayfinder/actions/App/Http/Controllers/LanguageController'

// Private instance of VueI18n object
let _i18n

// Initializer
function setup(options = { locale: 'default' }) {
  _i18n = createI18n({
    locale: options.locale || 'default',
    fallbackLocale: 'default'
  })
  setLocale(options.locale).then(() => {
    return _i18n
  })
}

function setLocale(locale) {
  return new Promise((resolve) => {
    // si les messages sont déjà loadé dans i18n
    if (
      locale !== 'default' &&
      _i18n.global.availableLocales.includes(locale)
    ) {
      // Switch the current i18n locale
      _i18n.global.locale = locale
      // Helpers outside components (getTranslatedText, momentLocalised) read it
      store.commit('i18n/setLocale', { locale })
      // Send the new locale in the X-Locale header of API requests
      apiClient.defaults.headers.common['X-Locale'] = locale
      apiClientDocument.defaults.headers.common['X-Locale'] = locale
      apiClientScreen.defaults.headers.common['X-Locale'] = locale

      // on change le lang dans l'HTML
      document.querySelector('html').setAttribute('lang', locale)
      return nextTick(() => {
        resolve()
      })
    } else {
      apiClient
        .route(LanguageController.translations.get({ local: locale }))
        .then((response) => {
          if (_i18n.global.fallbackLocale === 'default') {
            _i18n.global.fallbackLocale = response.data.local
          }
          // on pousse les messages dans i18n
          _i18n.global.setLocaleMessage(
            response.data.local,
            response.data.translations
          )
          // Switch the current i18n locale
          _i18n.global.locale = response.data.local
          store.commit('i18n/setLocale', { locale: response.data.local })
          // Send the new locale in the X-Locale header of API requests
          apiClient.defaults.headers.common['X-Locale'] = response.data.local
          apiClientDocument.defaults.headers.common['X-Locale'] =
            response.data.local
          apiClientScreen.defaults.headers.common['X-Locale'] =
            response.data.local
          // on change le lang dans l'HTML
          document
            .querySelector('html')
            .setAttribute('lang', response.data.local)
          return nextTick(() => {
            resolve()
          })
        })
        .catch((reason) => {
          alert(reason)
        })
    }
  })
}

// Public interface
export default {
  get vueI18n() {
    return _i18n
  },
  setup,
  setLocale
}
